import { toast } from 'sonner'

const UPDATE_CHECK_INTERVAL_MS = 30 * 60 * 1000

function promptUpdate(waitingWorker: ServiceWorker): void {
  toast('New version available', {
    action: {
      label: 'Refresh',
      onClick: () => waitingWorker.postMessage({ type: 'SKIP_WAITING' }),
    },
  })
}

export function registerServiceWorker(): void {
  if (!('serviceWorker' in navigator) || !import.meta.env.PROD) return

  navigator.serviceWorker
    .register('/service-worker.js')
    .then((registration) => {
      if (registration.waiting && navigator.serviceWorker.controller) {
        promptUpdate(registration.waiting)
      }

      registration.addEventListener('updatefound', () => {
        const installingWorker = registration.installing
        if (!installingWorker) return

        installingWorker.addEventListener('statechange', () => {
          if (
            installingWorker.state === 'installed' &&
            navigator.serviceWorker.controller
          ) {
            promptUpdate(installingWorker)
          }
        })
      })

      /* Browsers already check for updates on navigation, but long-lived open tabs
       * (installed PWA sessions especially) may never navigate again. */
      setInterval(() => {
        void registration.update()
      }, UPDATE_CHECK_INTERVAL_MS)
    })
    .catch((registrationError: unknown) => {
      console.error('Service worker registration failed', registrationError)
    })

  /* Reload once the new worker takes control (only fires after a user clicks "Refresh"
   * and the waiting worker calls skipWaiting via postMessage — never on first install). */
  let hasReloaded = false
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (hasReloaded) return
    hasReloaded = true
    window.location.reload()
  })
}
